import EditMap from "../../../../components/DataCollection/Unifier/Maps/EditMap/EditMap"

const EditMapsScreen = () => {
  return (
    <>
    <EditMap/>
    </>
  )
}

export default EditMapsScreen